// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2OSBB","header":"ClearentDisclaimer_header__bX9GU","inner":"ClearentDisclaimer_inner__2I6C9"};